import { createContext } from "react";

export const CurrentContext = createContext(null);